import { render, staticRenderFns } from "./orderSheet.vue?vue&type=template&id=049e51a8&scoped=true"
import script from "./orderSheet.vue?vue&type=script&lang=js"
export * from "./orderSheet.vue?vue&type=script&lang=js"
import style0 from "./orderSheet.vue?vue&type=style&index=0&id=049e51a8&lang=scss&scoped=true"
import style1 from "./orderSheet.vue?vue&type=style&index=1&id=049e51a8&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049e51a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('049e51a8')) {
      api.createRecord('049e51a8', component.options)
    } else {
      api.reload('049e51a8', component.options)
    }
    module.hot.accept("./orderSheet.vue?vue&type=template&id=049e51a8&scoped=true", function () {
      api.rerender('049e51a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/orderSheet.vue"
export default component.exports